module.exports = __webpack_public_path__ + "img/a5d6c0d.png";